import MainLayout from '@/common/components/layouts/MainLayout';
import ImagesFabMainModal from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/ImagesFabMainModal';
import Stepper from '@/modules/adjusterReportModules/IncidentParticipants/components/common/Stepper';
import { stepDriverData } from '@/modules/adjusterReportModules/IncidentParticipants/data/stepsData';
import { DriverInfoTypeForm } from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/driver-owner/driverInfo/driverInfo.type';
import { driverInfoQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDriverInfo/driverInfoQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { PropsWithChildren, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { Box, Divider } from 'styled-system/jsx';

export default ({ children }: PropsWithChildren) => {
  return (
    <MainLayout title="زیان‌دیده / راننده " header="closeHeader">
      <>
        <Divider color="gray-2" />
        <DriverInfo>{children}</DriverInfo>
      </>
    </MainLayout>
  );
};

const DriverInfo = ({ children }: PropsWithChildren) => {
  const { id, damagedId } = useParams();
  const { data: driverInfo } = useQuery(
    driverInfoQueryOptions({
      damaged_id: Number(damagedId),
      id: Number(id),
    }),
  );
  const methods = useForm<DriverInfoTypeForm>({
    mode: 'onChange',
  });

  useEffect(() => {
    if (driverInfo) {
      methods.reset({
        ...driverInfo,
        certificate_information: {
          license_number: driverInfo?.certificate_information?.license_number,
          license_type: driverInfo?.certificate_information?.license_type?.value
            ? {
                ...driverInfo?.certificate_information?.license_type,
                value: String(
                  driverInfo?.certificate_information?.license_type?.value,
                ),
              }
            : undefined,
          license_issue_date:
            driverInfo?.certificate_information?.license_issue_date ?? '',
          license_issue_location_country: driverInfo?.certificate_information
            ?.license_issue_location_country?.value
            ? {
                ...driverInfo?.certificate_information
                  ?.license_issue_location_country,
                value: String(
                  driverInfo?.certificate_information
                    ?.license_issue_location_country?.value,
                ),
              }
            : undefined,
        },
      });
    }
  }, [driverInfo, methods]);

  return (
    <>
      <Box width="100%" pt={'24px'}>
        <Stepper steps={stepDriverData} width="80%" />
      </Box>
      <Box
        w="100%"
        mx="auto"
        mt={40}
        mb={24}
        border="1px solid"
        borderColor="gray-2"
      ></Box>
      <Box width="100%">
        <FormProvider {...methods}>{children}</FormProvider>
      </Box>
      <ImagesFabMainModal state="propertyDamaged" />
    </>
  );
};
